<template>
  <div class="section" id="repayment-summary">
    <div class="container" id="summary-items">
      <div class="summary-items-header">
        <div class="title"><h5>Repayment Summary</h5></div>
        <a
          href=""
          class="toggle-btn"
          :aria-label="isOpen ? 'collapse' : 'expand'"
          @click.prevent="toggleSection"
        >
          <icon class="toggle-icon" :icon="isOpen ? 'chevron-up' : 'chevron-down'"></icon>
        </a>
      </div>
      <div class="summary-items" v-show="isOpen || !isMobile">
        <div class="summary-item">
          <p>Rate Type</p>
          <p>{{ repaymentSummary?.rateType || "—" }}</p>
        </div>
        <div class="summary-item">
          <p>Repayment Term</p>
          <p>
            {{ repaymentSummary?.repaymentTerm || "—" }}&nbsp;
            <span class="sc-tooltip-container" v-if="hasRepaymentTermTooltip">
              <icon icon="info" class="tooltip-toggle" />
              <span class="tooltip-text bottom no-arrow-indicator">
                {{ ratePlan?.repaymentTermDetails?.tooltipText }}
              </span>
            </span>
          </p>
        </div>
        <div class="summary-item">
          <p>Repayment Type</p>
          <p>{{ repaymentSummary?.repaymentType || "—" }}</p>
        </div>
        <div class="summary-item">
          <p>Interest Rate</p>
          <p>{{ repaymentSummary?.interestRate || "—" }}</p>
        </div>
      </div>
    </div>

    <small class="container">Selections are not final until process is completed.</small>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Icon from "@/components/shared/Icon.vue";
import type { RatePlanVM } from "@/models/loanConfiguration";

const props = withDefaults(
  defineProps<{ repaymentSummary: any; isMobile?: boolean; ratePlan?: RatePlanVM }>(),
  {
    isMobile: false,
  },
);

const route = useRoute();
const router = useRouter();
const isOpen = ref<boolean>(true);

const key = "repaymentSummary";

const hasRepaymentTermTooltip = computed<boolean>(() => {
  return (
    (props.ratePlan &&
      props.ratePlan?.repaymentTermDetails &&
      props.ratePlan?.repaymentTermDetails?.tooltipText !== null &&
      props.ratePlan?.repaymentTermDetails?.tooltipText !== undefined) === true
  );
});

function toggleSection() {
  isOpen.value = !isOpen.value;

  router.push({
    query: {
      ...route.query, // Preserve existing queries
      repaymentSummary: isOpen.value ? "expanded" : "collapsed", // Add/update the 'step' query
    },
  });
}

onMounted(() => {
  // get the url parameter
  if (Object.keys(route.query).includes(key)) {
    // check if value is valid
    const validKeys = ["expanded", "collapsed"];

    if (validKeys.includes(route.query[key]?.toString() || "")) {
      route.query[key]?.toString() === "expanded" ? (isOpen.value = true) : (isOpen.value = false);
    }
  }
});

defineExpose({
  isOpen,
});
</script>
<style scoped>
.sections .section#repayment-summary {
  text-align: left;
  flex: 0 1 220px;
}

.section#repayment-summary .container {
  padding: 12px;
  padding-bottom: 0;
}

.section#repayment-summary .summary-items {
  margin-bottom: 3px;
  /* padding: 10px 10px 0; */
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
  border-radius: 6px;
  background: #f2f3f5;
}

.section#repayment-summary {
  text-align: left;
  display: flex;
  width: 220px;
  height: 202px;
  flex-direction: column;
  border-radius: 6px;
  background: #f2f3f5;
}

.section#repayment-summary h5 {
  color: #000;
  font-family: "Montserrat";
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 17.175px;
  /* 132.116% */
}

.section#repayment-summary h5 {
  color: #000;
  font-family: "Montserrat";
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 17.175px;
  margin: 0;
  padding: 0;
  margin-bottom: 5px;
}

.summary-item p {
  color: #000;
  font-family: "Montserrat";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17.175px;
  /* 143.126% */
  margin-bottom: 0px;
}

.summary-item p:first-of-type {
  color: #000;
  font-family: "Montserrat";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 17.175px; /* 143.126% */
  margin-bottom: 0px;
}

.summary-item p:last-of-type {
  margin: 0;
}

div.summary-item:last-of-type {
  margin-bottom: 5px;
}

.summary-items-header {
  display: flex;
  flex-direction: row;
}

.summary-items-header .toggle-btn {
  display: none;
  pointer-events: none;
  font-size: 10px;
}

@media (max-width: 992px) {
  .section#repayment-summary {
    width: 100%;
    height: 100%;
    text-align: left;
    padding: 16px;
    border-radius: 6px;
    background: #f2f3f5;
    margin-bottom: 18px;
    align-items: center;
    margin-top: 8px;
    padding-bottom: 8px;
  }

  .section#repayment-summary .summary-items {
    align-items: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    height: 100%;
    margin-bottom: 0;
  }

  .section#repayment-summary .summary-items .summary-item {
    width: calc(50% - 25px);
  }

  .section#repayment-summary:is(.desktop) {
    display: none;
  }

  .substep {
    padding: 6px 29px 10px;
  }

  .summary-items-header .title {
    width: calc(100% - 20px);
    text-align: left;
  }
  .section#repayment-summary .summary-items {
    padding: 0;
  }
  .icon.chevron-down:before,
  .icon-chevron-down:before .icon.chevron-up:before,
  .icon-chevron-up:before {
    color: #000;
    width: 16px;
    height: 10px;
    font-size: 12px;
  }

  .summary-items-header .toggle-btn {
    display: contents;
  }

  .summary-items-header:first-child {
    flex: 1;
  }

  .summary-items-header:last-child {
    flex: 0 0 19.2px;
  }

  .summary-items-header .toggle-btn .icon:before {
    display: inline-block;
    color: #000;
    pointer-events: all;
  }

  small {
    display: none;
  }

  .container#summary-items {
    margin: 0;
    padding: 0 !important;
  }
}
</style>

<style scoped src="@/styles/centered-tooltip.css"></style>
